import { request } from '../request';
import { ProfileInfo } from '@libs/models/common/systemUser';

export async function getUserInfo(): Promise<ProfileInfo> {
  const response = await request.get<UserInfoResponse>('/v2/identity/info');
  return {
    user: {
      ...response.data.user,
      locations: response.data.user.locations.map((location) => ({
        id: location.id,
        name: location.name,
      })),
    },
  };
}

type UserInfoResponse = {
  user: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    locations: {
      id: string;
      name: string;
    }[];
    avatar: string;
    roles: string[];
  };
  organization: {
    id: string;
    name: string;
    workWeekDayStart: 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
    billingType: {
      id: string;
      name: string;
      type: string;
      paywalls: Record<string, string>;
    };
  } | null;
};
